"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _APCryptoAddressInputComponent = _interopRequireDefault(require("./APCryptoAddressInputComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var APCryptoAddressInputContainer = (0, _reactRedux.connect)()(_APCryptoAddressInputComponent["default"]);
var ForwardedAPCryptoAddressInput = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(APCryptoAddressInputContainer, _extends({}, props, {
    forwardedRef: ref
  }));
});
ForwardedAPCryptoAddressInput.displayName = 'APCryptoAddressInput';
var _default = exports["default"] = ForwardedAPCryptoAddressInput;